import {formatter, request} from "@/utils/request";
import {ButtonArgs} from "@/components/WdiBus/Buttons/data";

export namespace FormSa {
  export const Path = {
    get: '/expenseapi/formSa/getFormSa',
    myActivityPrev: '/expenseapi/formSa/myActivityPrev',
    getFormSaDetailGroup: '/expenseapi/formSa/getFormSaDetailGroup',
    getSellInAndTargetInfoForCurrent: '/expenseapi/formSa/getSellInAndTargetInfoForCurrent',
    getSellInAndTargetInfoForApply: '/expenseapi/formSa/getSellInAndTargetInfoForApply',
    getSellInAndTargetInfos: '/expenseapi/formSa/getSellInAndTargetInfos',
    getSellInAndTargetDetailInfos: '/expenseapi/formSa/getSellInAndTargetDetailInfos',
    BatchClose: '/expenseapi/saButtons/batchClose',
    GetProductPrice: '/expenseapi/formSa/getProductPrice',
    searchRevenueExpense: '/expenseapi/formSa/searchRevenueExpense',
    searchRevenueExpenseApply: '/expenseapi/formSa/searchRevenueExpenseApply',
    PrintUrl: '/reportapi/print/formSaPrint',
    searchRevenueExpenseSoldTo: '/expenseapi/formSa/searchRevenueExpenseSoldTo',
    searchRevenueExpenseRegion: '/expenseapi/formSa/searchRevenueExpenseRegion',
    getReferenceHistoryVosForPd: '/expenseapi/formSa/getReferenceHistoryVosForPd',
  };

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.FormSa>>(Path.get, formatter(options));
  }

  export async function myActivityPrev(body: API.ActivityPrev) {
    const options = {
      method: 'POST',
      body: {
        ...body
      }
    };
    return request<API.QueryResult<API.ActivityPrev>>(Path.myActivityPrev, formatter(options));
  }

  export async function getFormSaDetailGroup(body: { formId: number, groupBy: string }) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<any>>(Path.getFormSaDetailGroup, formatter(options));
  }

  export async function getSellInAndTargetInfoForCurrent(body: { formSaId: number }) {
    const options = {
      method: 'POST',
      body: body
    };
    return request<API.ResponseResult<any[]>>(Path.getSellInAndTargetInfoForCurrent, formatter(options));
  }

  export async function getSellInAndTargetInfoForApply(body: { form: any, formSa: any, formSaDetails: any[] }) {
    const options = {
      method: 'POST',
      body: body
    };
    return request<API.ResponseResult<any[]>>(Path.getSellInAndTargetInfoForApply, formatter(options));
  }


  export async function getSellInAndTargetInfos(body: { formSaId: number, startDate: string, endDate: string }) {
    const options = {
      method: 'POST',
      body: body
    };
    return request<API.ResponseResult<any[]>>(Path.getSellInAndTargetInfos, formatter(options));
  }

  export async function getSellInAndTargetInfosBySoldToCodes(body: {
    soldToCodes: string,
    startDate: string,
    endDate: string
  }) {
    const options = {
      method: 'POST',
      body: body
    };
    return request<API.ResponseResult<any[]>>(Path.getSellInAndTargetInfos, formatter(options));
  }


  export async function getSellInAndTargetDetailInfos(body: {
    formSaId: number,
    soldToCode: string,
    fpStart: number,
    fpEnd: number
  }) {
    const options = {
      method: 'POST',
      body: body
    };
    return request<API.ResponseResult<any[]>>(Path.getSellInAndTargetDetailInfos, formatter(options));
  }

  export async function batchClose(ids: string) {
    const options = {
      method: 'GET',
      body: {
        ids: ids,
      },
    };
    return request<API.ResponseResult<any>>(Path.BatchClose, formatter(options));
  }

  export async function getProductPrice(body: API.ProductPriceSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.FormGoodsDetail>>(Path.GetProductPrice, formatter(options));
  }

  export async function searchRevenueExpense(formSaId: number) {
    const options = {
      method: 'GET',
      body: {
        "formSaId": formSaId
      }
    };
    return request<API.ResponseResult<any[]>>(Path.searchRevenueExpense, formatter(options));
  }

  export async function searchRevenueExpenseApply(body: { form: any, formSa: any, formSaDetails: any[] }) {
    const options = {
      method: 'POST',
      body: body
    };
    return request<API.ResponseResult<any[]>>(Path.searchRevenueExpenseApply, formatter(options));
  }

  export async function searchRevenueExpenseSoldTo(param: API.RevenueExpenseParam) {
    const options = {
      method: 'POST',
      body: {
        ...param
      }
    };
    return request<API.ResponseResult<any[]>>(Path.searchRevenueExpenseSoldTo, formatter(options));
  }

  export async function searchRevenueExpenseRegion(param: API.RevenueExpenseParam) {
    const options = {
      method: 'POST',
      body: {
        ...param
      }
    };
    return request<API.ResponseResult<any[]>>(Path.searchRevenueExpenseRegion, formatter(options));
  }

  export async function getReferenceHistoryVosForPd(formSaId: number) {
    const options = {
      method: 'GET',
      body: {
        formSaId: formSaId,
      },
    };
    return request<API.ResponseResult<any[]>>(Path.getReferenceHistoryVosForPd, formatter(options));
  }

  export namespace Buttons {
    export const Path = {
      get: '/bpapi/formBudgetProject/get',
      getHistory: '/bpapi/formBudgetProject/getHistory',
      validateEcPicker: '/expenseapi/saButtons/validateEcPicker',
      validateDetail: '/expenseapi/saButtons/validateDetail',
      apply: '/expenseapi/saButtons/apply',
      validate: '/expenseapi/saButtons/validate',
      delete: '/expenseapi/saButtons/delete',
      BUDGET_INFOS: '/expenseapi/saButtons/budgetInfos',
      WARNING_INFOS: '/expenseapi/saButtons/warningInfos',
      COUNT_OF_WARNING: '/expenseapi/saButtons/countOfWarning',
      DYNAMIC_INFOS: '/expenseapi/saButtons/dynamicInfos',
      completeDelivery: '/expenseapi/saButtons/completeDelivery',
      getFormSaDetailCompareCollections: '/expenseapi/saButtons/getFormSaDetailCompareCollections',
      downloadTempByEc: '/expenseapi/saButtons/downloadTempByEc',
      downloadTempForExport: '/expenseapi/saButtons/downloadTempForExport',
      allowViewSfaCollectionDetails: '/expenseapi/saButtons/allowViewSfaCollectionDetails',
      viewSfaCollectionDetails: '/expenseapi/saButtons/viewSfaCollectionDetails',
    };

    export async function getButtons(body: API.ButtonArgs) {
      const options = {
        method: 'POST',
        body: body
      };

      return request<API.ResponseResult<API.Button>>('/Api/SAButtons/Get', formatter(options));
    }

    export async function validatePicker(body: API.DoFormSADetailDTO) {
      const options = {
        method: 'POST',
        body: body
      };

      return request<API.ResponseResult<API.FormSaDetailVo>>(Path.validateEcPicker, formatter(options));
    }

    export async function validateDetail(body: {
      rowIndex: number,
      formSa: any,
      form?: any,
      ecId?: any,
      formSaDetail: any,
      formSaDetails: any[],
    }) {
      const options = {
        method: 'POST',
        body: body
      };

      return request<API.ResponseResult<API.FormSaDetailVo>>(Path.validateDetail, formatter(options));
    }

    export async function validate(body: { form: any, formSa: any, formSaDetails: any[] }) {
      const options = {
        method: 'POST',
        body: body
      };
      return request<API.ResponseResult<API.WdiPanelList>>(Path.validate, formatter(options));
    }

    export async function apply(body: { form: any, formSa: any, formSaDetails: any[] }) {
      const options = {
        method: 'POST',
        body: body
      };
      return request<API.ResponseResult<API.WdiPanelList>>(Path.apply, formatter(options));
    }

    export async function del(formId: number) {
      const options = {
        method: 'POST',
        body: {formId: formId}
      };
      return request<API.ResponseResult<any>>(Path.delete, formatter(options));
    }

    export async function budgetInfos(formId: number) {
      const options = {
        method: 'GET',
        body: {formId}
      };
      return request<API.ResponseResult<API.WdiPanelList>>(Path.BUDGET_INFOS, formatter(options));
    }

    export async function warningInfos(formId: number) {
      const options = {
        method: 'GET',
        body: {
          formId: formId,
        },
      };
      return request<API.ResponseResult<API.WdiPanelList>>(Path.WARNING_INFOS, formatter(options));
    }

    export async function countOfWarning(formId: number) {
      const options = {
        method: 'GET',
        body: {
          formId: formId,
        },
      };
      return request<API.ResponseResult<number>>(Path.COUNT_OF_WARNING, formatter(options));
    }

    export async function dynamicInfos(formId: number) {
      const options = {
        method: 'Get',
        body: {formId}
      };
      return request<API.DynamicInformation[]>(Path.DYNAMIC_INFOS, formatter(options));
    }

    export async function completeDelivery(body: API.ButtonArgs) {
      const options = {
        method: 'POST',
        body: body
      };

      return request<API.ResponseResult<any>>(Path.completeDelivery, formatter(options));
    }

    export async function getFormSaDetailCompareCollections(body: { formId: number, relatedFormId: number }) {
      const options = {
        method: 'GET',
        body: {
          ...body
        },
      };
      return request<API.ResponseResult<API.FormSaDetailCompareCollections>>(Path.getFormSaDetailCompareCollections, formatter(options));
    }

    export async function allowViewSfaCollectionDetails(id: number) {
      const options = {
        method: 'GET',
        body: {
          id: id
        },
      };
      return request<API.ResponseResult<boolean>>(Path.allowViewSfaCollectionDetails, formatter(options));
    }

    export async function viewSfaCollectionDetails(body: ButtonArgs) {
      const options = {
        method: 'POST',
        body: {
          ...body
        },
      };
      return request<API.ResponseResult<string>>(Path.viewSfaCollectionDetails, formatter(options));
    }
  }
}

export namespace FormSaDetail {
  export const Path = {
    get: '/expenseapi/formSa/getFormSaDetail',
    getEx: '/expenseapi/formSa/getFormSaDetailEx',
    gets: '/expenseapi/formSa/getFormSaDetails',
    getsEx: '/expenseapi/formSa/getFormSaDetailsEx',
    getFgEx: '/expenseapi/formSa/getFgFormSaDetailsEx',
    getDiscountsEx: '/expenseapi/formSa/getFormSaDiscountDetailsEx',
    getSaPdViewProcess: '/expenseapi/formSa/getSaPdViewProcess',
    getFormSaDetailVosForModifyAmount: '/expenseapi/formSa/getFormSaDetailVosForModifyAmount',
    getTop1FormSaDetail: '/expenseapi/formSa/getTop1FormSaDetail',
    getVosForModifyPaymentMethod: '/expenseapi/formSa/getVosForModifyPaymentMethod',
  };

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.FormSaDetail>>(Path.get, formatter(options));
  }

  export async function getEx(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.FormSaDetailVo>>(Path.getEx, formatter(options));
  }

  export async function gets(formSaId: number) {
    const options = {
      method: 'GET',
      body: {
        formSaId: formSaId,
      },
    };
    return request<API.ResponseResult<API.FormSaDetail[]>>(Path.gets, formatter(options));
  }

  export async function getTop1FormSaDetail(formSaId: number) {
    const options = {
      method: 'GET',
      body: {
        formSaId: formSaId,
      },
    };
    return request<API.ResponseResult<API.FormSaDetail>>(Path.getTop1FormSaDetail, formatter(options));
  }

  export async function getsEx(formSaId: number) {
    const options = {
      method: 'GET',
      body: {
        formSaId: formSaId,
      },
    };
    return request<API.ResponseResult<API.FormSaDetailVo[]>>(Path.getsEx, formatter(options));
  }

  export async function getFormSaDetailVosForModifyAmount(formSaId: number) {
    const options = {
      method: 'GET',
      body: {
        formSaId: formSaId,
      },
    };
    return request<API.ResponseResult<API.FormSaDetailVo[]>>(Path.getFormSaDetailVosForModifyAmount, formatter(options));
  }

  export async function getVosForModifyPaymentMethod(formSaId: number) {
    const options = {
      method: 'GET',
      body: {
        formSaId: formSaId,
      },
    };
    return request<API.ResponseResult<API.FormSaDetailVo[]>>(Path.getVosForModifyPaymentMethod, formatter(options));
  }

  export async function getDiscountsEx(formSaId: number) {
    const options = {
      method: 'GET',
      body: {
        formSaId: formSaId,
      },
    };
    return request<API.ResponseResult<API.FormSaDiscountDetailVo[]>>(Path.getDiscountsEx, formatter(options));
  }

  export async function getFgEx(formSaId: number) {
    const options = {
      method: 'GET',
      body: {
        formSaId: formSaId,
      },
    };
    return request<API.ResponseResult<API.FormSaDetailVo[]>>(Path.getFgEx, formatter(options));
  }

  export async function getSaPdViewProcess(formSaId: number) {
    const options = {
      method: 'GET',
      body: {
        formSaId: formSaId,
      },
    };
    return request<API.ResponseResult<any[]>>(Path.getSaPdViewProcess, formatter(options));
  }
}
